import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { CommonModule } from './common/common.module';
import { SecurityDepositRoutingModule } from './security-deposit-routing.module';

@NgModule({
  imports: [
    SharedModule,
    CommonModule.forRoot(),
    SecurityDepositRoutingModule
  ]
})
export class SecurityDepositModule { }
